<template>
    <div class="auth-page">
        <!-- 返回首页按钮 -->
        <router-link to="/" class="back-home">
            <ArrowLeftIcon :size="18" />
            返回首页
        </router-link>

        <!-- 左侧品牌展示区域 -->
        <div class="brand-section">
            <!-- 浮动装饰元素 -->
            <div class="floating-shapes">
                <div class="floating-shape"></div>
                <div class="floating-shape"></div>
                <div class="floating-shape"></div>
                <div class="floating-shape"></div>
                <div class="floating-shape"></div>
                <div class="floating-shape"></div>
                <!-- 添加更多装饰元素 -->
                <div class="floating-shape particle"></div>
                <div class="floating-shape particle"></div>
                <div class="floating-shape particle"></div>
            </div>

            <!-- 背景网格效果 -->
            <div class="grid-background"></div>

            <!-- 品牌内容 -->
            <div class="brand-content">
                <div class="brand-logo-container">
                    <img src="/images/mahiru-logo.svg" alt="Mahiru" class="brand-logo" />
                    <div class="logo-glow"></div>
                </div>

                <div class="brand-text">
                    <h1 class="brand-subtitle">我的个人博客空间</h1>
                    <div class="brand-description">
                        <p class="typing-text">记录生活点滴，分享技术心得</p>
                        <p class="fade-in-text">在这里，每一篇文章都是我的思考与成长</p>
                    </div>
                </div>

                <div class="brand-features">
                    <div class="feature-item">
                        <div class="feature-icon">
                            <PenToolIcon :size="20" />
                        </div>
                        <span>原创内容</span>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon">
                            <ShareIcon :size="20" />
                        </div>
                        <span>知识分享</span>
                    </div>
                    <div class="feature-item">
                        <div class="feature-icon">
                            <UsersIcon :size="20" />
                        </div>
                        <span>互动交流</span>
                    </div>
                </div>

                <!-- 添加底部装饰 -->
                <div class="brand-decoration">
                    <div class="wave-line"></div>
                    <div class="scroll-indicator">
                        <span>探索更多</span>
                        <div class="scroll-arrow"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧表单区域 -->
        <div class="form-section">
            <!-- 表单容器 -->
            <div class="form-container" :class="{ 'register-mode': isRegisterMode }">
                <!-- 登录表单 -->
                <div class="form-panel login-panel" :class="{ 'panel-hidden': isRegisterMode }">
                    <div class="form-content">
                        <h2 class="form-title">登录账号</h2>
                        <p class="form-subtitle">请输入您的账号信息</p>

                        <!-- 社交登录按钮 -->
                        <div class="social-buttons">
                            <button class="social-btn google" @click="loginGoogle" :disabled="oauthLoading.google">
                                <svg viewBox="0 0 24 24" width="16" height="16">
                                    <path fill="#4285F4"
                                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                    <path fill="#34A853"
                                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                    <path fill="#FBBC05"
                                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                    <path fill="#EA4335"
                                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                                </svg>
                                {{ oauthLoading.google ? '登录中...' : '使用 Google 登录' }}
                            </button>
                            <button class="social-btn github" @click="loginGithub" :disabled="oauthLoading.github">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                                    <path
                                        d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                                </svg>
                                {{ oauthLoading.github ? '登录中...' : '使用 GitHub 登录' }}
                            </button>
                        </div>

                        <div class="divider">
                            <span>或使用邮箱登录</span>
                        </div>

                        <!-- 登录表单 -->
                        <form @submit.prevent="onLogin" class="auth-form">
                            <div class="input-group">
                                <label class="input-label">邮箱地址</label>
                                <input v-model="loginForm.email" type="email" class="form-input" placeholder="请输入您的邮箱"
                                    required />
                            </div>

                            <div class="input-group">
                                <label class="input-label">密码</label>
                                <div class="input-with-icon">
                                    <input v-model="loginForm.password" :type="showLoginPassword ? 'text' : 'password'"
                                        class="form-input" placeholder="请输入密码" required />
                                    <button type="button" class="input-icon-btn"
                                        @click="showLoginPassword = !showLoginPassword">
                                        <EyeIcon v-if="!showLoginPassword" :size="18" />
                                        <EyeOffIcon v-else :size="18" />
                                    </button>
                                </div>
                            </div>

                            <div class="form-options">
                                <label class="checkbox-label">
                                    <input type="checkbox" v-model="loginForm.rememberMe" />
                                    <span class="checkmark"></span>
                                    记住我
                                </label>
                                <a href="#" class="link-text">忘记密码？</a>
                            </div>

                            <button type="submit" class="submit-btn" :disabled="loginLoading">
                                <span v-if="loginLoading">登录中...</span>
                                <span v-else>登录</span>
                            </button>
                        </form>

                        <div class="form-footer">
                            <p>还没有账号？ <button @click="switchToRegister" class="link-btn">立即注册</button></p>
                        </div>
                    </div>
                </div>

                <!-- 注册表单 -->
                <div class="form-panel register-panel" :class="{ 'panel-visible': isRegisterMode }">
                    <div class="form-content">
                        <h2 class="form-title">创建账号</h2>
                        <p class="form-subtitle">请填写以下信息完成注册</p>

                        <!-- 注册表单 -->
                        <form @submit.prevent="onRegister" class="auth-form">
                            <div class="input-group">
                                <label class="input-label">用户名</label>
                                <input v-model="registerForm.username" type="text" class="form-input"
                                    :class="{ 'input-error': usernameError }" placeholder="请输入用户名（英文、数字、下划线）"
                                    @input="validateUsername" @blur="validateUsername" maxlength="30" required />
                                <div v-if="usernameValidating" class="validating-message">
                                    <svg class="loading-spinner" viewBox="0 0 24 24" width="14" height="14">
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"
                                            fill="none" opacity="0.25" />
                                        <path fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    正在验证用户名...
                                </div>
                                <div v-else-if="usernameError" class="error-message">{{ usernameError }}</div>
                                <div v-else-if="usernameValidated && registerForm.username" class="success-message">
                                    <CheckIcon :size="14" /> 用户名可用
                                </div>
                            </div>

                            <div class="input-group">
                                <label class="input-label">邮箱地址</label>
                                <input v-model="registerForm.email" type="email" class="form-input"
                                    :class="{ 'input-error': emailError }" placeholder="请输入您的邮箱" @input="validateEmail"
                                    @blur="validateEmail" required />
                                <div v-if="emailValidating" class="validating-message">
                                    <svg class="loading-spinner" viewBox="0 0 24 24" width="14" height="14">
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"
                                            fill="none" opacity="0.25" />
                                        <path fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                    </svg>
                                    正在验证邮箱...
                                </div>
                                <div v-else-if="emailError" class="error-message">{{ emailError }}</div>
                                <div v-else-if="emailValidated && registerForm.email" class="success-message">
                                    <CheckIcon :size="14" /> 邮箱可用
                                </div>
                            </div>

                            <div class="input-group">
                                <label class="input-label">密码</label>
                                <div class="input-with-icon">
                                    <input v-model="registerForm.password"
                                        :type="showRegisterPassword ? 'text' : 'password'" class="form-input"
                                        placeholder="设置密码（至少6位）" @input="checkPasswordStrength" required />
                                    <button type="button" class="input-icon-btn"
                                        @click="showRegisterPassword = !showRegisterPassword">
                                        <EyeIcon v-if="!showRegisterPassword" :size="18" />
                                        <EyeOffIcon v-else :size="18" />
                                    </button>
                                </div>

                                <!-- 密码强度指示器 -->
                                <div v-if="registerForm.password" class="password-strength">
                                    <div class="strength-bar">
                                        <div class="strength-fill"
                                            :style="{ width: passwordStrength.width, background: passwordStrength.color }">
                                        </div>
                                    </div>
                                    <span class="strength-text" :style="{ color: passwordStrength.color }">{{
                                        passwordStrength.text }}</span>
                                </div>
                            </div>

                            <div class="input-group">
                                <label class="input-label">确认密码</label>
                                <div class="input-with-icon">
                                    <input v-model="registerForm.confirmPassword"
                                        :type="showConfirmPassword ? 'text' : 'password'" class="form-input"
                                        :class="{ 'input-error': registerForm.confirmPassword && registerForm.password !== registerForm.confirmPassword }"
                                        placeholder="请再次输入密码" required />
                                    <button type="button" class="input-icon-btn"
                                        @click="showConfirmPassword = !showConfirmPassword">
                                        <EyeIcon v-if="!showConfirmPassword" :size="18" />
                                        <EyeOffIcon v-else :size="18" />
                                    </button>
                                </div>
                                <div v-if="registerForm.confirmPassword && registerForm.password !== registerForm.confirmPassword"
                                    class="error-message">
                                    两次输入的密码不一致
                                </div>
                            </div>

                            <div class="form-options">
                                <label class="checkbox-label">
                                    <input type="checkbox" v-model="registerForm.agreeTerms" required />
                                    <span class="checkmark"></span>
                                    我同意 <a href="#" class="link-text">服务条款</a> 和 <a href="#" class="link-text">隐私政策</a>
                                </label>
                            </div>

                            <button type="submit" class="submit-btn" :disabled="registerLoading || !canSubmit">
                                <span v-if="registerLoading">注册中...</span>
                                <span v-else>注册</span>
                            </button>
                        </form>

                        <div class="form-footer">
                            <p>已有账号？ <button @click="switchToLogin" class="link-btn">立即登录</button></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { ArrowLeftIcon, EyeIcon, EyeOffIcon, CheckIcon, PenToolIcon, ShareIcon, UsersIcon } from 'lucide-vue-next'
import supabaseAuthService from '../services/supabaseAuthService.js'

export default {
    name: 'AuthPage',
    components: {
        ArrowLeftIcon,
        EyeIcon,
        EyeOffIcon,
        CheckIcon,
        PenToolIcon,
        ShareIcon,
        UsersIcon
    },
    data() {
        return {
            isRegisterMode: false,

            // 登录表单
            loginForm: {
                email: '',
                password: '',
                rememberMe: false
            },
            loginLoading: false,
            showLoginPassword: false,

            // 注册表单
            registerForm: {
                username: '',
                email: '',
                password: '',
                confirmPassword: '',
                agreeTerms: false
            },
            registerLoading: false,
            showRegisterPassword: false,
            showConfirmPassword: false,
            usernameError: '',
            emailError: '',
            passwordStrength: {
                width: '0%',
                color: '#ef4444',
                text: ''
            },

            // 验证状态
            usernameValidating: false,
            emailValidating: false,
            usernameValidated: false,
            emailValidated: false,

            // 防抖定时器
            usernameDebounceTimer: null,
            emailDebounceTimer: null,

            // OAuth加载状态
            oauthLoading: {
                google: false,
                github: false
            }
        }
    },
    computed: {
        canSubmit() {
            return this.registerForm.username &&
                this.registerForm.email &&
                this.registerForm.password &&
                this.registerForm.password === this.registerForm.confirmPassword &&
                this.registerForm.agreeTerms &&
                !this.usernameError &&
                !this.emailError &&
                this.usernameValidated &&
                this.emailValidated &&
                !this.usernameValidating &&
                !this.emailValidating
        }
    },
    mounted() {
        // 检查路由参数是否指定默认模式
        if (this.$route.query.mode === 'register') {
            this.isRegisterMode = true
        }
    },
    beforeUnmount() {
        // 清理防抖定时器
        if (this.usernameDebounceTimer) {
            clearTimeout(this.usernameDebounceTimer)
        }
        if (this.emailDebounceTimer) {
            clearTimeout(this.emailDebounceTimer)
        }
    },
    methods: {
        switchToLogin() {
            this.isRegisterMode = false
        },

        switchToRegister() {
            this.isRegisterMode = true
        },

        validateUsername() {
            const username = this.registerForm.username
            if (!username) {
                this.usernameError = ''
                this.usernameValidated = false
                return
            }

            // 用户名验证：只能包含英文、数字、下划线，长度不超过30字符
            const usernameRegex = /^[a-zA-Z0-9_]+$/
            if (!usernameRegex.test(username)) {
                this.usernameError = '用户名只能包含英文、数字和下划线'
                this.usernameValidated = false
                return
            }

            if (username.length < 3) {
                this.usernameError = '用户名至少需要3个字符'
                this.usernameValidated = false
                return
            }

            if (username.length > 30) {
                this.usernameError = '用户名不能超过30个字符'
                this.usernameValidated = false
                return
            }

            this.usernameError = ''

            // 防抖验证用户名是否存在
            if (this.usernameDebounceTimer) {
                clearTimeout(this.usernameDebounceTimer)
            }

            this.usernameDebounceTimer = setTimeout(() => {
                this.checkUsernameAvailability(username)
            }, 800)
        },

        async checkUsernameAvailability(username) {
            if (!username || this.usernameError) return

            this.usernameValidating = true
            this.usernameValidated = false

            try {
                const exists = await supabaseAuthService.checkUsernameExists(username)

                if (exists) {
                    this.usernameError = '该用户名已被使用'
                    this.usernameValidated = false
                } else {
                    this.usernameError = ''
                    this.usernameValidated = true
                }
            } catch (error) {
                this.usernameError = '验证用户名时发生错误，请稍后重试'
                this.usernameValidated = false
            } finally {
                this.usernameValidating = false
            }
        },

        validateEmail() {
            const email = this.registerForm.email
            if (!email) {
                this.emailError = ''
                this.emailValidated = false
                return
            }

            // 基本邮箱格式验证
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(email)) {
                this.emailError = '请输入有效的邮箱地址'
                this.emailValidated = false
                return
            }

            this.emailError = ''

            // 防抖验证邮箱是否存在
            if (this.emailDebounceTimer) {
                clearTimeout(this.emailDebounceTimer)
            }

            this.emailDebounceTimer = setTimeout(() => {
                this.checkEmailAvailability(email)
            }, 800)
        },

        async checkEmailAvailability(email) {
            if (!email || this.emailError) return

            this.emailValidating = true
            this.emailValidated = false

            try {
                const exists = await supabaseAuthService.checkEmailExists(email)

                if (exists) {
                    this.emailError = '该邮箱已被注册'
                    this.emailValidated = false
                } else {
                    this.emailError = ''
                    this.emailValidated = true
                }
            } catch (error) {
                this.emailError = '验证邮箱时发生错误，请稍后重试'
                this.emailValidated = false
            } finally {
                this.emailValidating = false
            }
        },

        checkPasswordStrength() {
            const password = this.registerForm.password
            if (!password) {
                this.passwordStrength = { width: '0%', color: '#ef4444', text: '' }
                return
            }

            let score = 0
            let tips = []

            // 长度检查
            if (password.length >= 8) score += 1
            else tips.push('至少8位字符')

            // 包含数字
            if (/\d/.test(password)) score += 1
            else tips.push('包含数字')

            // 包含小写字母
            if (/[a-z]/.test(password)) score += 1
            else tips.push('包含小写字母')

            // 包含大写字母
            if (/[A-Z]/.test(password)) score += 1
            else tips.push('包含大写字母')

            // 包含特殊字符
            if (/[^a-zA-Z0-9]/.test(password)) score += 1
            else tips.push('包含特殊字符')

            // 根据得分设置强度
            if (score <= 2) {
                this.passwordStrength = {
                    width: '33%',
                    color: '#ef4444',
                    text: `弱 - 建议${tips.slice(0, 2).join('、')}`
                }
            } else if (score <= 3) {
                this.passwordStrength = {
                    width: '66%',
                    color: '#f59e0b',
                    text: `中等 - 建议${tips.slice(0, 1).join('、')}`
                }
            } else {
                this.passwordStrength = {
                    width: '100%',
                    color: '#00c851',
                    text: '强 - 密码安全性良好'
                }
            }
        },

        async onLogin() {
            this.loginLoading = true
            try {
                await supabaseAuthService.signInWithPassword(this.loginForm.email, this.loginForm.password)
                message.success('登录成功！')
                this.$router.push('/')
            } catch (e) {
                message.error(e.message || '登录失败')
            } finally {
                this.loginLoading = false
            }
        },

        async onRegister() {
            // 最终验证
            if (!this.canSubmit) {
                message.error('请完善所有信息并等待验证完成')
                return
            }

            this.registerLoading = true
            try {
                await supabaseAuthService.signUpWithPassword(
                    this.registerForm.email,
                    this.registerForm.password,
                    { display_name: this.registerForm.username }
                )
                message.success('注册成功！请查看邮箱验证邮件')
                this.switchToLogin()
            } catch (e) {
                message.error(e.message || '注册失败')
            } finally {
                this.registerLoading = false
            }
        },

        async loginGoogle() {
            this.oauthLoading.google = true
            try {
                await supabaseAuthService.signInWithGoogle()
            } catch (e) {
                message.error(e.message || 'Google 登录失败')
            } finally {
                this.oauthLoading.google = false
            }
        },

        async loginGithub() {
            this.oauthLoading.github = true
            try {
                await supabaseAuthService.signInWithGithub()
            } catch (e) {
                message.error(e.message || 'GitHub 登录失败')
            } finally {
                this.oauthLoading.github = false
            }
        }
    }
}
</script>

<style scoped>
/* 全局样式重置 */
* {
    box-sizing: border-box;
}

html,
body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
}

/* 主容器 - 全屏布局 */
.auth-page {
    width: 100vw;
    height: 100vh;
    display: flex;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

/* 返回按钮 */
.back-home {
    position: absolute;
    top: 30px;
    left: 30px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: white;
    text-decoration: none;
    padding: 12px 20px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
    z-index: 100;
    font-weight: 500;
}

.back-home:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

/* 左侧品牌展示区域 */
.brand-section {
    flex: 0 0 45%;
    background: linear-gradient(135deg, #00c851 0%, #00a844 30%, #00d962 70%, #26d07c 100%);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    animation: brandGlow 8s ease-in-out infinite;
    box-sizing: border-box;
}

@keyframes fadeInDelayed {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 0.85;
        transform: translateY(0);
    }
}

/* 增强背景渐变动画 */
@keyframes brandGlow {

    0%,
    100% {
        background: linear-gradient(135deg, #00c851 0%, #00a844 30%, #00d962 70%, #26d07c 100%);
        box-shadow: inset 0 0 50px rgba(255, 255, 255, 0.1);
    }

    25% {
        background: linear-gradient(135deg, #00d962 0%, #26d07c 30%, #00c851 70%, #00a844 100%);
        box-shadow: inset 0 0 80px rgba(255, 255, 255, 0.15);
    }

    50% {
        background: linear-gradient(135deg, #26d07c 0%, #00c851 30%, #00a844 70%, #00d962 100%);
        box-shadow: inset 0 0 100px rgba(255, 255, 255, 0.2);
    }

    75% {
        background: linear-gradient(135deg, #00a844 0%, #00d962 30%, #26d07c 70%, #00c851 100%);
        box-shadow: inset 0 0 80px rgba(255, 255, 255, 0.15);
    }
}

/* 浮动装饰元素 */
.floating-shapes {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
}

.floating-shape {
    position: absolute;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    animation: float 15s ease-in-out infinite;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(2px);
}

.floating-shape:nth-child(1) {
    width: 80px;
    height: 80px;
    top: 15%;
    left: 10%;
    animation-delay: 0s;
    animation-duration: 12s;
}

.floating-shape:nth-child(2) {
    width: 140px;
    height: 140px;
    top: 60%;
    right: 12%;
    animation-delay: 4s;
    animation-duration: 16s;
}

.floating-shape:nth-child(3) {
    width: 50px;
    height: 50px;
    top: 75%;
    left: 25%;
    animation-delay: 8s;
    animation-duration: 10s;
}

.floating-shape:nth-child(4) {
    width: 100px;
    height: 100px;
    top: 25%;
    right: 35%;
    animation-delay: 12s;
    animation-duration: 14s;
}

/* 添加更多装饰元素 */
.floating-shape:nth-child(5) {
    width: 30px;
    height: 30px;
    top: 40%;
    left: 5%;
    animation-delay: 2s;
    animation-duration: 8s;
}

.floating-shape:nth-child(6) {
    width: 70px;
    height: 70px;
    top: 85%;
    right: 5%;
    animation-delay: 6s;
    animation-duration: 18s;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0px) translateX(0px) rotate(0deg) scale(1);
        opacity: 0.15;
    }

    25% {
        transform: translateY(-25px) translateX(15px) rotate(90deg) scale(1.1);
        opacity: 0.35;
    }

    50% {
        transform: translateY(-20px) translateX(25px) rotate(180deg) scale(0.9);
        opacity: 0.5;
    }

    75% {
        transform: translateY(-30px) translateX(8px) rotate(270deg) scale(1.05);
        opacity: 0.3;
    }
}

/* 背景网格效果 */
.grid-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:
        radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
        radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
    background-size: 30px 30px, 20px 20px;
    opacity: 0.3;
    pointer-events: none;
    z-index: 1;
    animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
    0% {
        transform: translateX(0) translateY(0);
    }

    25% {
        transform: translateX(-10px) translateY(-5px);
    }

    50% {
        transform: translateX(-20px) translateY(-10px);
    }

    75% {
        transform: translateX(-10px) translateY(-5px);
    }

    100% {
        transform: translateX(0) translateY(0);
    }
}

/* 品牌内容 */
.brand-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: white;
    max-width: 450px;
    padding: 0 40px;
    animation: fadeInUp 1.2s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.brand-logo-container {
    margin-bottom: 30px;
    animation: logoFloat 6s ease-in-out infinite;
    position: relative;
}

@keyframes logoFloat {

    0%,
    100% {
        transform: translateY(0px) rotate(0deg);
    }

    50% {
        transform: translateY(-10px) rotate(2deg);
    }
}

.brand-logo {
    width: 280px;
    height: auto;
    max-width: 90%;
    filter: brightness(0) invert(1);
    transition: all 0.4s ease;
    display: block;
    margin: 0 auto;
}

.brand-logo:hover {
    transform: scale(1.05);
    filter: brightness(0) invert(1) drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
}

.logo-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 320px;
    height: 80px;
    transform: translate(-50%, -50%);
    border-radius: 40px;
    background: radial-gradient(ellipse, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
    opacity: 0.6;
    z-index: -1;
    animation: glowPulse 4s ease-in-out infinite;
}

/* 增强浮动粒子效果 */
.floating-shape.particle {
    width: 8px;
    height: 8px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 50%;
    animation: particleFloat 10s ease-in-out infinite;
}

.floating-shape.particle:nth-child(7) {
    top: 20%;
    left: 15%;
    animation-delay: 1s;
    animation-duration: 8s;
}

.floating-shape.particle:nth-child(8) {
    top: 70%;
    right: 20%;
    animation-delay: 3s;
    animation-duration: 12s;
}

.floating-shape.particle:nth-child(9) {
    top: 45%;
    left: 5%;
    animation-delay: 5s;
    animation-duration: 9s;
}

@keyframes particleFloat {

    0%,
    100% {
        transform: translateY(0px) translateX(0px) scale(1);
        opacity: 0.3;
    }

    25% {
        transform: translateY(-40px) translateX(20px) scale(1.2);
        opacity: 0.8;
    }

    50% {
        transform: translateY(-20px) translateX(40px) scale(0.8);
        opacity: 0.6;
    }

    75% {
        transform: translateY(-60px) translateX(10px) scale(1.1);
        opacity: 0.4;
    }
}

@keyframes glowPulse {
    0% {
        transform: scale(1);
        opacity: 0.5;
    }

    50% {
        transform: scale(1.1);
        opacity: 0.7;
    }

    100% {
        transform: scale(1);
        opacity: 0.5;
    }
}

.brand-text {
    margin-bottom: 40px;
    animation: slideInLeft 1s ease-out 0.3s both;
}

@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }

    to {
        opacity: 0.95;
        transform: translateX(0);
    }
}

.brand-subtitle {
    font-size: 1.25rem;
    margin-bottom: 20px;
    opacity: 0.95;
    font-weight: 400;
    letter-spacing: 1px;
    animation: slideInLeft 1s ease-out 0.3s both;
}

@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }

    to {
        opacity: 0.95;
        transform: translateX(0);
    }
}

.brand-description {
    margin-bottom: 40px;
    line-height: 1.7;
    font-size: 1.05rem;
    opacity: 0.9;
    animation: slideInRight 1s ease-out 0.6s both;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(30px);
    }

    to {
        opacity: 0.9;
        transform: translateX(0);
    }
}

.brand-description p {
    margin-bottom: 16px;
    font-weight: 300;
    transition: all 0.3s ease;
}

.brand-description p:hover {
    transform: translateX(5px);
    opacity: 1;
}

/* 修复打字机效果 */
.typing-text {
    font-size: 1.05rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 400;
    letter-spacing: 0.5px;
    animation: typing 3s steps(20, end) 1s both, blinkCursor 1s infinite step-end 1s;
    white-space: nowrap;
    overflow: hidden;
    border-right: 3px solid rgba(255, 255, 255, 0.8);
    width: 0;
    margin-bottom: 16px;
}

@keyframes typing {
    from {
        width: 0;
    }

    to {
        width: 100%;
    }
}

@keyframes blinkCursor {

    0%,
    50% {
        border-color: rgba(255, 255, 255, 0.8);
    }

    51%,
    100% {
        border-color: transparent;
    }
}

.fade-in-text {
    font-size: 1.05rem;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 300;
    letter-spacing: 0.5px;
    opacity: 0;
    animation: fadeInDelayed 1s ease-in-out 4.5s forwards;
}

.brand-features {
    display: flex;
    gap: 25px;
    justify-content: center;
    flex-wrap: wrap;
    animation: fadeInUp 1s ease-out 0.9s both;
}

.feature-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    opacity: 0.95;
    transition: all 0.4s ease;
    cursor: pointer;
    animation: bounceIn 0.6s ease-out;
}

.feature-item:nth-child(2) {
    animation-delay: 1.2s;
}

.feature-item:nth-child(3) {
    animation-delay: 1.5s;
}

@keyframes bounceIn {
    0% {
        opacity: 0;
        transform: scale(0.3) translateY(20px);
    }

    50% {
        opacity: 1;
        transform: scale(1.05) translateY(-5px);
    }

    70% {
        transform: scale(0.9) translateY(0);
    }

    100% {
        opacity: 0.95;
        transform: scale(1) translateY(0);
    }
}

.feature-item:hover {
    opacity: 1;
    transform: translateY(-12px) scale(1.05);
}

.feature-icon {
    width: 56px;
    height: 56px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s ease;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
}

.feature-icon::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
}

.feature-item:hover .feature-icon::before {
    left: 100%;
}

.feature-item:hover .feature-icon {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.1) rotate(8deg);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15), 0 0 20px rgba(255, 255, 255, 0.2);
}

.feature-item span {
    font-size: 0.95rem;
    font-weight: 500;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.feature-item:hover span {
    transform: scale(1.05);
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* 底部装饰 */
.brand-decoration {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    animation: fadeInUp 0.8s ease-out 1.2s both;
}

.wave-line {
    width: 100px;
    height: 2px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 1px;
    margin-bottom: 15px;
    animation: wave 2s infinite ease-in-out;
}

@keyframes wave {
    0% {
        transform: translateX(-100%);
    }

    50% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(-100%);
    }
}

.scroll-indicator {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    font-weight: 500;
    letter-spacing: 0.5px;
    animation: fadeInUp 0.6s ease-out 1.4s both;
}

.scroll-arrow {
    width: 10px;
    height: 10px;
    border-right: 2px solid;
    border-bottom: 2px solid;
    transform: rotate(-45deg);
    animation: scrollArrowBounce 1.5s infinite ease-in-out;
}

@keyframes scrollArrowBounce {

    0%,
    100% {
        transform: translateY(0) rotate(-45deg);
    }

    50% {
        transform: translateY(5px) rotate(-45deg);
    }
}

/* 右侧表单区域 */
.form-section {
    flex: 1;
    background: white;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 40px 60px 40px;
    min-height: 100vh;
    box-sizing: border-box;
}

.form-container {
    width: 100%;
    max-width: 450px;
    position: relative;
    box-sizing: border-box;
    margin-top: 20px;
}

/* 注册模式下的特殊样式 */
.form-container.register-mode {
    margin-top: 0;
}

.form-container.register-mode .form-section {
    align-items: flex-start;
    padding-top: 20px;
}

/* 表单面板 */
.form-panel {
    position: relative;
    width: 100%;
    transition: all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transform: translateX(0);
    opacity: 1;
    box-sizing: border-box;
}

/* 登录面板动画 */
.form-panel.panel-hidden {
    transform: translateX(-100%);
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
}

/* 注册面板动画 */
.register-panel {
    transform: translateX(100%);
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
}

.register-panel.panel-visible {
    transform: translateX(0);
    opacity: 1;
    position: relative;
}

/* 表单内容 */
.form-content {
    width: 100%;
    padding: 0;
    animation: formSlideIn 0.8s ease-out;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

@keyframes formSlideIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.form-content:hover {
    /* 移除悬浮效果 */
}

.form-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
    text-align: center;
    animation: titleFadeIn 0.6s ease-out 0.2s both;
    letter-spacing: -0.025em;
    line-height: 1.2;
}

@keyframes titleFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.form-subtitle {
    color: #64748b;
    text-align: center;
    margin-bottom: 48px;
    font-size: 1.1rem;
    animation: subtitleFadeIn 0.6s ease-out 0.4s both;
    font-weight: 400;
    line-height: 1.5;
}

@keyframes subtitleFadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* 社交登录按钮 */
.social-buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;
    animation: socialButtonsSlideIn 0.6s ease-out 0.6s both;
}

@keyframes socialButtonsSlideIn {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.social-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px 24px;
    border: 1.5px solid #e2e8f0;
    border-radius: 16px;
    background: #ffffff;
    color: #374151;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    position: relative;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.social-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(0, 200, 81, 0.05), transparent);
    transition: left 0.5s ease;
}

.social-btn:hover::before {
    left: 100%;
}

.social-btn:hover {
    border-color: #00c851;
    background: #f8fffe;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 200, 81, 0.15);
}

.social-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* 分割线 */
.divider {
    position: relative;
    text-align: center;
    margin: 32px 0;
}

.divider::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e2e8f0;
}

.divider span {
    background: white;
    color: #64748b;
    padding: 0 24px;
    font-size: 0.9rem;
    position: relative;
    font-weight: 500;
}

/* 表单样式 */
.auth-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
    animation: formFieldsSlideIn 0.6s ease-out 0.8s both;
    width: 100%;
    box-sizing: border-box;
}

@keyframes formFieldsSlideIn {
    from {
        opacity: 0;
        transform: translateY(15px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.input-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
}

.input-label {
    font-weight: 600;
    color: #374151;
    font-size: 0.95rem;
    margin-bottom: 4px;
    letter-spacing: -0.025em;
}

.form-input {
    padding: 16px 20px;
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    font-size: 1rem;
    background: #ffffff;
    transition: all 0.3s ease;
    position: relative;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    color: #1f2937;
    font-weight: 400;
    line-height: 1.5;
}

.form-input::placeholder {
    color: #9ca3af;
    font-weight: 400;
}

.form-input:focus {
    outline: none;
    border-color: #00c851;
    box-shadow: 0 0 0 3px rgba(0, 200, 81, 0.1);
    background: #fefffe;
}

.form-input:hover:not(:focus) {
    border-color: #cbd5e1;
    background: #fafafa;
}

.form-input.input-error {
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

/* 输入框图标按钮 */
.input-with-icon {
    position: relative;
}

.input-icon-btn {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #6b7280;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.input-icon-btn:hover {
    color: #00c851;
    background: rgba(0, 200, 81, 0.1);
}

/* 表单选项 */
.form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin: 8px 0;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    color: #4b5563;
    font-size: 0.95rem;
    font-weight: 500;
    transition: color 0.2s ease;
}

.checkbox-label:hover {
    color: #374151;
}

.checkbox-label input[type="checkbox"] {
    display: none;
}

.checkmark {
    width: 20px;
    height: 20px;
    border: 2px solid #d1d5db;
    border-radius: 6px;
    position: relative;
    transition: all 0.3s ease;
    background: #ffffff;
    flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark {
    background: #00c851;
    border-color: #00c851;
    transform: scale(1.05);
}

.checkbox-label input[type="checkbox"]:checked+.checkmark::after {
    content: '✓';
    position: absolute;
    top: -1px;
    left: 3px;
    color: white;
    font-size: 14px;
    font-weight: bold;
}

.link-text {
    color: #00c851;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.95rem;
    transition: all 0.2s ease;
}

.link-text:hover {
    color: #00a844;
    text-decoration: underline;
}

/* 提交按钮 */
.submit-btn {
    padding: 18px 32px;
    background: linear-gradient(135deg, #00c851 0%, #00a844 100%);
    color: white;
    border: none;
    border-radius: 16px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 16px rgba(0, 200, 81, 0.3);
    margin-top: 16px;
    position: relative;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    letter-spacing: -0.025em;
}

.submit-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
}

.submit-btn:hover::before {
    left: 100%;
}

.submit-btn:hover {
    background: linear-gradient(135deg, #00a844 0%, #009e40 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 200, 81, 0.4);
}

.submit-btn:active {
    transform: translateY(0);
    box-shadow: 0 4px 12px rgba(0, 200, 81, 0.3);
}

.submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 4px 16px rgba(0, 200, 81, 0.2);
}

/* 表单底部 */
.form-footer {
    text-align: center;
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #f1f5f9;
}

.form-footer p {
    color: #64748b;
    font-size: 0.95rem;
    font-weight: 400;
    margin: 0;
}

.link-btn {
    background: none;
    border: none;
    color: #00c851;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;
    font-size: 0.95rem;
    padding: 0;
    margin-left: 4px;
}

.link-btn:hover {
    color: #00a844;
    text-decoration: underline;
}

/* 验证消息样式 */
.validating-message {
    color: #6b7280;
    font-size: 0.875rem;
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    animation: messageSlideIn 0.3s ease-out;
}

.loading-spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 错误和成功消息 */
.error-message {
    color: #dc2626;
    font-size: 0.875rem;
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    animation: messageSlideIn 0.3s ease-out;
}

@keyframes messageSlideIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.success-message {
    color: #059669;
    font-size: 0.875rem;
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    animation: messageSlideIn 0.3s ease-out;
}

/* 密码强度指示器 */
.password-strength {
    margin-top: 12px;
    animation: strengthSlideIn 0.4s ease-out;
}

@keyframes strengthSlideIn {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.strength-bar {
    width: 100%;
    height: 6px;
    background: #f1f5f9;
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 8px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.strength-fill {
    height: 100%;
    transition: all 0.4s ease;
    border-radius: 3px;
    background: linear-gradient(90deg, currentColor, currentColor);
}

.strength-text {
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: -0.025em;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .brand-section {
        flex: 0 0 42%;
    }

    .brand-content {
        max-width: 420px;
        padding: 50px 30px;
    }

    .brand-logo {
        width: 240px;
    }

    .logo-glow {
        width: 280px;
        height: 70px;
    }

    .form-content {
        max-width: 450px;
        padding: 40px 30px;
    }
}

@media (max-width: 968px) {
    .auth-page {
        flex-direction: column;
        overflow-x: hidden;
    }

    /* 小屏隐藏品牌区域 */
    .brand-section {
        display: none;
    }

    .form-section {
        flex: 1;
        padding: 32px 24px;
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;
    }

    .form-container {
        max-width: 100%;
        width: 100%;
    }

    .form-content {
        padding: 0;
        width: 100%;
    }

    .form-title {
        font-size: 2.25rem;
        margin-bottom: 16px;
    }

    .form-subtitle {
        font-size: 1rem;
        margin-bottom: 40px;
    }

    .social-buttons {
        gap: 14px;
        margin-bottom: 28px;
    }

    .social-btn {
        padding: 14px 20px;
        border-radius: 14px;
    }

    .auth-form {
        gap: 20px;
    }

    .form-input {
        padding: 14px 16px;
        border-radius: 10px;
    }

    .submit-btn {
        padding: 16px 24px;
        font-size: 1rem;
        border-radius: 14px;
    }

    .back-home {
        top: 20px;
        left: 20px;
        padding: 10px 16px;
        background: rgba(0, 200, 81, 0.9);
        color: white;
    }

    .back-home:hover {
        background: rgba(0, 168, 68, 0.9);
    }
}

@media (max-width: 768px) {
    .brand-section {
        display: block;
        flex: 0 0 35vh;
        min-height: 35vh;
    }

    .brand-content {
        padding: 20px 15px;
        max-width: 100%;
    }

    .brand-logo {
        width: 200px;
        max-width: 85%;
    }

    .logo-glow {
        width: 240px;
        height: 60px;
    }

    .brand-text {
        margin-bottom: 25px;
    }

    .brand-subtitle {
        font-size: 1.1rem;
        margin-bottom: 15px;
    }

    .typing-text,
    .fade-in-text {
        font-size: 0.95rem;
    }

    .brand-features {
        gap: 15px;
        margin-bottom: 20px;
    }

    .feature-icon {
        width: 40px;
        height: 40px;
    }

    .feature-item span {
        font-size: 0.85rem;
    }

    .brand-decoration {
        margin-top: 20px;
    }

    .wave-line {
        width: 60px;
    }

    .scroll-indicator {
        font-size: 0.8rem;
    }

    .form-section {
        flex: 1;
        min-height: 65vh;
        padding: 20px 15px;
    }
}

@media (max-width: 480px) {
    .brand-section {
        flex: 0 0 30vh;
        min-height: 30vh;
    }

    .brand-content {
        padding: 15px 10px;
    }

    .brand-logo {
        width: 160px;
    }

    .logo-glow {
        width: 200px;
        height: 50px;
    }

    .brand-subtitle {
        font-size: 1rem;
        margin-bottom: 10px;
    }

    .typing-text,
    .fade-in-text {
        font-size: 0.9rem;
    }

    .brand-features {
        flex-direction: row;
        justify-content: space-around;
        gap: 10px;
        flex-wrap: wrap;
    }

    .feature-item {
        flex-direction: column;
        align-items: center;
        gap: 5px;
        min-width: 60px;
    }

    .feature-icon {
        width: 32px;
        height: 32px;
    }

    .feature-item span {
        font-size: 0.75rem;
    }

    .brand-decoration {
        display: none;
    }

    .form-section {
        padding: 24px 16px;
        overflow-x: hidden;
        width: 100%;
    }

    .form-content {
        padding: 0;
        width: 100%;
    }

    .form-title {
        font-size: 2rem;
        margin-bottom: 12px;
    }

    .form-subtitle {
        font-size: 0.95rem;
        margin-bottom: 36px;
    }

    .social-buttons {
        gap: 12px;
        margin-bottom: 24px;
    }

    .social-btn {
        padding: 12px 16px;
        font-size: 0.95rem;
        border-radius: 12px;
    }

    .auth-form {
        gap: 18px;
    }

    .form-input {
        padding: 12px 14px;
        font-size: 16px;
        /* 防止iOS缩放 */
    }

    .submit-btn {
        padding: 14px 20px;
        font-size: 0.95rem;
    }

    .form-options {
        gap: 12px;
        margin: 6px 0;
    }

    .checkbox-label {
        font-size: 0.9rem;
    }

    .form-footer {
        margin-top: 28px;
        padding-top: 20px;
    }

    .back-home {
        top: 15px;
        left: 15px;
        padding: 8px 12px;
        font-size: 0.9rem;
    }
}
</style>